import React, { useMemo } from 'react';
import { canShowGlobalSearchEntity } from '../context/utils/globalSearchUtil';
import { useGlobalSearchContext } from '../hooks/useGlobalSearchContext';
import { GlobalSearchEntityList } from './GlobalSearchEntityList/GlobalSearchEntityList';

export function GlobalSearchBody() {
  const {
    state
  } = useGlobalSearchContext();

  const list = useMemo(() => {
    const entityMapping: [boolean, string][] = Object.keys(state.items)
      .sort((a, b) => state.items[a].metaData.sortOrder - state.items[b].metaData.sortOrder)
      .map((key) => [canShowGlobalSearchEntity(state, key), key]);

    return entityMapping
      .filter(([condition]) => condition)
      .map(([, entity]) => entity);
  }, [state]);

  return (
    <div
      data-id='global-search-dialog-body-inner'
      className='w-100 h-100 overflow-auto'
    >
      {list.map((item) => (
        <GlobalSearchEntityList
          key={item}
          entityType={item}
          entity={state.items[item]}
        />
      ))}
    </div>
  );
}
